<app-button
	btn="secondary"
	[icon]="ICON.BACK"
	size="small"
	(click)="goToIntegrations()"
	[testHook]="testHooks.BackToIntegrationsButton"
	>Back to integrations</app-button
>
